<template>
  <OperativeTable :dense="dense">
    <OperativeTableHeader :years="yearsTableHeadings" />
    <tbody>
    <OperativeTableBodyHeader :years="yearsTableHeadings">Impieghi</OperativeTableBodyHeader>
    <OperativeTableBodyRow :values="yearsTableRows.attivoImmobilizzato">
      Attivo immobilizzato
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.scorte">
      Scorte
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.clienti">
      Clienti
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>

    <OperativeTableBodyRow :values="yearsTableRows.creditiTributari">
      Crediti tributari
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow v-if="isModuleSubsidizedFinanceEnabled" :values="yearsTableRows.creditiContributiDaErogare">
      Crediti per contributi da erogare
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.altriCrediti">
      Altri crediti
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.creditoImposta">
      Credito d'imposta
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.liquiditaImmediate">
      Liquidità immediate
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.riservaRettificaImpieghi" em>
      Riserva di rettifica
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.totaleCapitaleInvestito" strong>
      Totale capitale investito
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>

    <OperativeTableBodyHeader :years="yearsTableHeadings">Fonti</OperativeTableBodyHeader>
    <OperativeTableBodyRow :values="yearsTableRows.patrimonioNetto" strong>
      Patrimonio netto
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.equity" strong>
      Equity
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.capitaleSociale">
      Capitale sociale
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.prestitoSoci">
      Prestito soci
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.riserve">
      Altre riserve
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.utiliPerditePregresse">
      Riserve di utili
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.utilePerdita">
      Utile/Perdita
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.passivitaConsolidate" strong>
      Passività consolidate
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.finanziamentiMLTermine">
      Finanziamenti a Medio/Lungo Termine
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.fondi">
      Fondi
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.passivitaCorrenti" strong>
      Passività correnti
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.bancheBreve">
      Banche a breve
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.rateMLTermineScadenza">
      Rate Medio/Lungo Termine in scadenza
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.fornitori">
      Fornitori
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.fiscaliPrevidenziali">
      Fiscali e previdenziali
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.altriDebiti">
      Altri debiti
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.riscontiPassivi">
      Risconti passivi
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.riservaRettificaFonti" em>
      Riserva di rettifica
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.totaleCapitaleAcquisito" strong>
      Totale capitale acquisito
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    </tbody>
  </OperativeTable>
</template>

<script>

import computedFinancialDataMixin from '@/mixins/computedFinancialData.js';
import formatMoneyFilter from '@/filters/formatMoney.js';
import operativePageMixin from '@/mixins/operativePage.js';

export default {
  mixins: [operativePageMixin, computedFinancialDataMixin],
  components: {
    OperativeTable: () => import('@/views/components/Operative/OperativeTable.vue'),
    OperativeTableBodyRow: () => import('@/views/components/Operative/OperativeTableBodyRow.vue'),
    OperativeTableBodyHeader: () => import('@/views/components/Operative/OperativeTableBodyHeader.vue'),
    OperativeTableHeader: () => import('@/views/components/Operative/OperativeTableHeader.vue'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    yearsTableRows: {
      default: null,
      type: Object,
    },
    yearsTableHeadings: {
      default: null,
      type: Array,
    },
    dense: {
      default: false,
      type: Boolean,
    },
    isModuleSubsidizedFinanceEnabled: {
      default: false,
      type: Boolean,
    },
  },
  data () {
    return {
      years: [],
    };
  },
};

</script>
